import styled from 'styled-components';

const StyledRevertButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  border-radius: 50%;
  cursor: pointer;
  margin: ${({ $margin }) => $margin};
  &:hover {
    background-color: #eaedf3;
  }
`;

const styledRevertIconButton = {
  StyledRevertButton,
};

export default styledRevertIconButton;
